module.exports = __webpack_public_path__ + "static/fsBuyNow-484bf94f3999e62058654e81387159e2.png";